import { createSlice } from "@reduxjs/toolkit";

// Track lookup: prefix -> name mapping
// Example: { "ENTT": "External noise track", "B/H": "Low friction and handling area" }
const initialState: TracksLookup = {};

export const tracksSlice = createSlice({
  name: "tracks",
  initialState: initialState,
  reducers: {
    update: (state, action) => {
      return action.payload.tracks || {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { update } = tracksSlice.actions;

export default tracksSlice.reducer;

export interface TracksLookup {
  [prefix: string]: string; // prefix -> track name
}
